const FADE_DURATION_MS = 100;
const button = "_61bedns79";
const throbber = "_61tr0h3z3";

export { FADE_DURATION_MS, button, throbber };
import "./_print.style.linaria.module.css";
//# sourceMappingURL=_print.style.js.map
